import { render, staticRenderFns } from "./ViewDetailLongSentences.vue?vue&type=template&id=881661c0&scoped=true&"
import script from "./ViewDetailLongSentences.vue?vue&type=script&lang=js&"
export * from "./ViewDetailLongSentences.vue?vue&type=script&lang=js&"
import style0 from "./ViewDetailLongSentences.vue?vue&type=style&index=0&id=881661c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881661c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
